import { Directive, Input, TemplateRef } from '@angular/core';
import { GenericDirectiveTemplateContext } from '../interfaces';

@Directive({
  selector: 'ng-template[dataItemContext]',
  standalone: true,
})
export class TemplateGaurdDirective<T extends object> {
  @Input('dataItemContext') data!: T[] | T;
  constructor() {}

  static ngTemplateContextGuard<
    TContextItem extends object,
    Context extends GenericDirectiveTemplateContext<TContextItem>
  >(dir: TemplateGaurdDirective<TContextItem>, ctx: unknown): ctx is Context {
    return true;
  }
}
